import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M13.0002 20.999L13.0002 5.211L18.0102 10.532C18.3882 10.934 19.0212 10.953 19.4242 10.574C19.8252 10.196 19.8442 9.563 19.4662 9.16L13.2262 2.532C12.9192 2.208 12.4962 2.017 12.0562 2.001C12.0372 2 12.0192 2 12.0002 2C11.9812 2 11.9612 2 11.9422 2.001C11.5032 2.017 11.0802 2.209 10.7752 2.533L4.53524 9.161C4.35324 9.354 4.26424 9.6 4.26424 9.847C4.26424 10.113 4.36924 10.378 4.57824 10.575C4.98024 10.953 5.61324 10.934 5.99224 10.533L11.0002 5.213L11.0002 21C11.0002 21.553 11.4482 22 12.0002 22C12.5522 22 13.0002 21.552 13.0002 20.999Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'ArrowUpward');

export default Icon;
